const themeMeta = {
  typography: {
    fontFamily: 'Poppins, sans-serif',
    titleBold: {
      fontWeight: 'bold',
      fontSize: 24,
      lineHeight: 1.33,
    },
    textLarge: {
      fontSize: 20,
      lineHeight: 1.6,
    },
    textLargeBold: {
      fontWeight: 'bold',
      fontSize: 20,
      lineHeight: 1.6,
    },
    textMedium: {
      fontSize: 18,
      lineHeight: 1.56,
    },
    textMediumBold: {
      fontWeight: 600,
      fontSize: 18,
      lineHeight: 1.56,
    },
    textSmall: {
      fontSize: 16,
      lineHeight: 1.5,
    },
    textSmallBold: {
      fontWeight: 600,
      fontSize: 16,
      lineHeight: 1.5,
    },
    textXsmall: {
      fontSize: 14,
      lineHeight: 1.57,
    },
    textXsmallBold: {
      fontWeight: 600,
      fontSize: 14,
      lineHeight: 1.57,
    },
  },
  colors: {
    monochrome: {
      offBlack: '#14142B',
      ash: '#262338',
      body: '#4E4B66',
      label: '#6E7191',
      placehold: '#A0A3BD',
      line: '#D9DBE9',
      input: '#eff0f7',
      bg: '#F7F7FC',
      offWhite: '#fcfcfc',
      white: '#fff',
    },
    primary: {
      default: '#9FEB4D',
      dark: '#427B06',
      light: '#BCF182',
      bg: '#E9FFC0',
    },
    secondary: {
      default: '#04F0D6',
      dark: '#2B476F',
      light: '#B3F7EF',
      bg: '#CAFEF8',
    },
    success: {
      default: '#71C416',
      dark: '#5EA512',
      light: '#E9FFC0',
      darkMode: '#9FEB4D',
    },
    warning: {
      default: '#63349C',
      light: '#DDC1FF',
      bg: '#9C71D0',
    },
    error: {
      default: '#FF644F',
      dark: '#BA1700',
      light: '#FFCEC7',
      bg: '#FFB6AC',
    },
    green: {
      100: '#eaf9de',
      200: '#CBFFAE',
      600: '#008a00',
    },
    lavendar: {
      100: '#F2F0FF',
      200: '#C4B6FF',
      600: '#6C00AE',
    },
    blue: {
      100: '#E3FEFF',
      200: '#8DE9FF',
      600: '#005BD4',
    },
  },
}

export { themeMeta }
